import "shared/styles/Home.css";

import React, {useCallback, useState} from "react";
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";

import {Role, useAuth} from "features/auth";
import {adminService} from "features/admin";

const Menu = () => {
    const { role } = useAuth();
    const [extendedIdx, setExtendedIdx] = useState(-1);

    const clearCache = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm("Do you really want to remove all cached files and category data? This action cannot be undone!");
        if (confirmed) {
            adminService.clearAllCache().then(resp => {
                if (resp.errorCode !== undefined) {
                    alert(`Error: ${resp.errorCode}`);
                } else {
                    if (resp.success) {
                        alert("All the cache successfully deleted!");
                    }
                }
            });
        }
    }, [])

    return (
        <div className="menu-page">
            <div className="menu-wrapper">
                <MenuLinkSection sectionName="Advanced Data View" ownIdx={1} extendedIdx={extendedIdx} setExtendedIdx={setExtendedIdx}>
                    <LinkButton path="/excel-diff" text="Excel Comparison"/>
                    <LinkButton path="/custom-diff" text="Custom Comparison"/>
                    <LinkButton path="/pvr" text="PVR Documents"/>
                </MenuLinkSection>
                <MenuLinkSection sectionName="Analysis" ownIdx={2} extendedIdx={extendedIdx} setExtendedIdx={setExtendedIdx}>
                    <LinkButton path="/categories" text="Validation Rules Search"/>
                    <LinkButton path="/manufacturer-analysis" text="Manufacturer's Healthcheck"/>
                </MenuLinkSection>
                {role === Role.Administrator || role === Role.SuperAdmin?
                    <MenuLinkSection sectionName="Admin Actions" ownIdx={3} extendedIdx={extendedIdx} setExtendedIdx={setExtendedIdx}>
                        <LinkButton path="/users" text="Manage Users"/>
                        {role === Role.SuperAdmin?
                            <FakeLinkButton text="Clear All Cache" action={clearCache}/> : <></>}
                    </MenuLinkSection>
                     : <></>}
                <LinkButton path="/logs" text="View Logs"/>
            </div>
        </div>
    );
};

const LinkButton = ({path, text}: {path: string, text: string}) => {
    return (
        <Link className="link" to={path}>
            <p className="link-button-text">{text}</p>
        </Link>
    );
}

const FakeLinkButton = ({action, text}: { text: string, action: () => void }) => {
    return (
        <div className="link" style={{cursor: "pointer"}} onClick={action}>
            <p className="link-button-text">{text}</p>
        </div>
    );
}

const MenuLinkSection = ({children, extendedIdx, ownIdx, sectionName, setExtendedIdx}: { sectionName: string, ownIdx: number, extendedIdx: number, setExtendedIdx: React.Dispatch<React.SetStateAction<number>>, children: React.ReactNode }) => {
    return (
        <div className="link-section-wrapper">
            <div className="link-section-container" style={{cursor: "pointer"}} onClick={() => ownIdx === extendedIdx? setExtendedIdx(-1) : setExtendedIdx(ownIdx)}>
                <div></div>
                <p className="link-button-text">{sectionName}</p>
                <div className="chevron-wrapper">
                    <FontAwesomeIcon icon={ownIdx === extendedIdx ? faChevronUp : faChevronDown}/>
                </div>
            </div>
            <div className="extendable-links-section" style={{display: ownIdx === extendedIdx ? "flex" : "none"}}>
                <div></div>
                {children}
            </div>
        </div>
    );
}

export default Menu;
